import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  CategoryIcon,
  SpecialtyIcon,
  FamilyIcon,
  FunctionTypeIcon,
  FunctionaryTypeIcon,
  PositionsClassificationIcon,
  LaborUnionsIcon,
  PaymentTypesIcon,
  DigitalWarehouseFileTypeIcon,
  FestivitiesTableIcon,
  BenefitsCenterIcon,
  ProjectsIcon,
  ActionTypesIcon,
  HolidayTableIcon,
  GroupClassificationIcon,
  CommunicationClassificationIcon,
  FeedbackPurposeIcon,
  AccumIcon,
  PositionEditorIcon,
} from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = ({ history }) => {

  const data = [
    {
      name: getLocalizedString("functionaryTypesSettings"),
      icon: <FunctionaryTypeIcon />,
      path: paths.functionaryTypesSettings,
    },
    {
      name: getLocalizedString("familyMemberTypes"),
      icon: <FamilyIcon />,
      path: paths.familySettings,
    },
    {
      name: getLocalizedString("filtercategory"),
      icon: <CategoryIcon />,
      path: paths.categoriesSettings,
    },
    {
      name: getLocalizedString("filterspecialty"),
      icon: <SpecialtyIcon />,
      path: paths.specialtiesSettings,
    },
    {
      name: getLocalizedString("functionsSettings"),
      icon: <FunctionTypeIcon />,
      path: paths.functionsSettings,
    },
    {
      name: getLocalizedString("positionsClassification"),
      icon: <PositionsClassificationIcon />,
      path: paths.positionsClassification,
    },
    {
      name: getLocalizedString("filterunion"),
      icon: <LaborUnionsIcon />,
      path: paths.laborUnions,
    },
    {
      name: getLocalizedString("paymentTypes"),
      icon: <PaymentTypesIcon />,
      path: paths.paymentTypes,
    },
    {
      name: getLocalizedString("digitalWarehouseFileTypes"),
      icon: <DigitalWarehouseFileTypeIcon />,
      path: paths.digitalWarehouseFileTypes,
    },
    {
      name: getLocalizedString("festivitiesTable"),
      icon: <FestivitiesTableIcon />,
      path: paths.festivitiesTable,
    },
    {
      name: getLocalizedString("benefitsCenter"),
      icon: <BenefitsCenterIcon />,
      path: paths.benefitsCenter,
    },
    {
      name: getLocalizedString("centersSettings"),
      icon: <PositionEditorIcon />,
      path: paths.centersSettings,
    },
    {
      name: getLocalizedString("projects"),
      icon: <ProjectsIcon />,
      path: paths.projects,
    },
    {
      name: getLocalizedString("actionTypesAndReminders"),
      icon: <ActionTypesIcon />,
      path: paths.actionTypes,
    },
    {
      name: getLocalizedString("holidayTable"),
      icon: <HolidayTableIcon />,
      path: paths.holidayTable,
    },
    {
      name: getLocalizedString("groupClassification"),
      icon: <GroupClassificationIcon />,
      path: paths.groupClassification,
    },
    {
      name: getLocalizedString("communicationClassification"),
      icon: <CommunicationClassificationIcon />,
      path: paths.communicationClassification,
    },
    {
      name: getLocalizedString("feedbackPurpose"),
      icon: <FeedbackPurposeIcon />,
      path: paths.feedbackPurpose,
      onClick: () => {
        history.push({
          pathname: paths.feedbackPurpose,
          state: {
            from: paths.organizationalDefinitions,
          },
        });
      }
    },
    {
      name: getLocalizedString("currencySettings"),
      icon: <AccumIcon />,
      path: paths.currencySettings,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("organizationalDefinitions")}
      data={data}
    />
  );
}

export default Index;
